import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet';
import MuiPhoneNumber from "material-ui-phone-number"
import ReactCodeInput from 'react-verification-code-input';
import styles from "./style.module.css";


import { FormControl, Typography } from "@material-ui/core";

import { Button } from "../../../common/components/libs";
import { observer } from "mobx-react";
import { useStores } from "../../../hooks";
import Wrapper from "../components/wrapper";
import { NavLink, Redirect, useHistory } from "react-router-dom";
import { SnackbarType } from "../../../stores/common";
import logo from "../../../common/assets/logo_big.png";
import { trackLogIn } from "../../utils/MetrikaService";
import {Trans, useTranslation} from "react-i18next";
import { Currency } from "../../../services/constantsRegistry/models";

enum Steps {
    enterPhone,
    enterSMS
}

const SignIn = () => {
    const {i18n, t} = useTranslation(["general", "auth"]);
    const [phone, setPhone] = useState("");
    const [step, setStep] = useState(Steps.enterPhone);

    const { authStore, generalStore, constantsStore } = useStores();
    const history = useHistory();

    useEffect(() => {
        authStore.getCurrentUser().then(()=>{
            const locale =  authStore.organizationBranch?
                authStore.organizationBranch.data.defaultLocaleId:
                "ru";
            generalStore.setLocale({
                id: locale
            });
            const currencyNameId = authStore.organizationBranch?
                authStore.organizationBranch.data.defaultCurrencyId:
                "RUB";
            const currencyName = constantsStore.getLocalisedCurrencyName(currencyNameId);
            const currencyShortName = constantsStore.getLocalisedCurrencyShortName(currencyNameId);
            const currency = {id: currencyNameId, decimalPlaces: 2, currencyName: {[locale]: currencyName}, currencyShortName: {[locale]: currencyShortName}};
            generalStore.setCurrency(currency);
            i18n.changeLanguage(locale);
        })
    }, [authStore]);

    if (authStore.isAuthorized) {
        return <Redirect to="/"/>
    }

    const requestCode = async () => {
        const phoneNumber = phone.replace(/\s/g, "").slice(1);
        const isOk = await authStore.requestAuthCode(phoneNumber);
        if (!isOk) {
            /*generalStore.showSnackbar({
                type: SnackbarType.error,
                title: "Ошибка при отправке кода",
                description: "Убедитесь, что вы ввели правильный номер телефона"
            });*/
            history.push(`/auth/${phoneNumber}/create-account`)
        } else {
            setStep(Steps.enterSMS);

        }
    };

    const onSmsComplete = async (value: string) => {
        const phoneNumber = phone.replace(/\s/g, "").slice(1);
        const isOk = await authStore.enterAuthCode({
            phoneNumber,
            authCode: value
        });
        if (!isOk) {
            generalStore.showSnackbar({
                type: SnackbarType.error,
                title: t("auth:incorrectCode"),
                description: t("auth:enterIncorrectNumber")
            })
        }else{
            trackLogIn();
        }
    };

    return (
        <div>
            <Wrapper>
                <Helmet title={t("auth:authorization")}/>
                <form>
                    {
                        step === Steps.enterPhone && <>
                            <Typography component="h1" variant="h4" align="center" gutterBottom>
                                {t("auth:welcome")}
                            </Typography>
                            <Typography component="h4" variant="body2" align="center" gutterBottom>
                                {t("auth:enterNumber")}
                            </Typography>
                            <FormControl margin="normal" required fullWidth>
                                <MuiPhoneNumber
                                    defaultCountry={'ru'}
                                    id="phone"
                                    onChange={setPhone}
                                    value={phone}
                                />
                                <br/>
                            </FormControl>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                mb={2}
                                onClick={requestCode}
                                disabled={phone.length !== 18}
                            >
                                {t("auth:sendSms")}
                            </Button>
                            <Button
                                component={NavLink}
                                to="/auth/sign-up"
                                fullWidth
                                color="primary"
                            >
                                {t("auth:notHaveAccount")}
                            </Button>
                        </>
                    }
                    {
                        step === Steps.enterSMS && <>
                            <Typography component="h1" variant="h4" align="center" gutterBottom>
                                {t("auth:enterSmsCode")}
                            </Typography>
                            <Typography component="h4" variant="body2" align="center" gutterBottom>
                                {t("auth:weSentCodeToNumber")} <br/>{phone}
                            </Typography>
                            <FormControl margin="normal" required fullWidth>
                                <ReactCodeInput
                                    onComplete={onSmsComplete}
                                    //@ts-ignore
                                    autofocus={true}
                                    fields={4}
                                    className={styles.enterSMSCode}
                                />
                                <br/>
                            </FormControl>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                mb={2}
                                disabled={true}
                            >
                                {t("auth:signIn")}
                            </Button>
                            <Button
                                component={NavLink}
                                to="/auth/sign-up"
                                fullWidth
                                color="primary"
                            >
                                {t("general:back")}
                            </Button>
                        </>
                    }
                </form>
            </Wrapper>
            <div style={{ textAlign: "center", marginTop: 20, marginLeft: -10 }}>
                <img src={logo} alt="" style={{ height: 20 }}/>
            </div>
        </div>
    );
};

export default observer(SignIn);

